// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** The look of right-click menus (Radix ContextMenu): the file tree's and the vault lists'. */
import { ContextMenu } from "radix-ui";
import type { ReactNode } from "react";

export const contextMenuContentClass = "z-50 min-w-48 rounded-lg border border-border bg-overlay p-1 text-sm shadow-overlay";

export function ContextMenuItem({ children, onSelect }: { children: ReactNode; onSelect: () => void }) {
  return (
    <ContextMenu.Item
      onSelect={onSelect}
      className="flex h-8 cursor-pointer items-center gap-4 rounded-md px-2 outline-none data-[highlighted]:bg-surface-muted"
    >
      {children}
    </ContextMenu.Item>
  );
}

export function ContextMenuSeparator() {
  return <ContextMenu.Separator className="my-1 h-px bg-border" />;
}
